// extracted by mini-css-extract-plugin
module.exports = {"image":"Meals_image__181_1"};